// Helpers for refreshing Quick Check courses when the intended-subject list changes.
export const subjectsKey = (list) =>
  (list || []).filter((s) => s != null).map((s) => String(s).trim()).filter(Boolean).join("|");

// What the user had open, so the same countries/bands reopen with the new subjects' courses.
export function reopenPlan(expanded, openBands) {
  const countries = Object.keys(expanded || {}).filter((c) => expanded[c]);
  return {
    countries,
    expanded: Object.fromEntries(countries.map((c) => [c, true])),
    openBands: Object.fromEntries(countries.filter((c) => openBands?.[c]).map((c) => [c, { ...openBands[c] }])),
  };
}

export const countryStates = (countries, state) =>
  Object.fromEntries(countries.map((c) => [c, { results: [], excluded: [], ...state }]));
